const min = minVal => (value, previousValue) =>
  value >= minVal ? value : previousValue
export default min



// WEBPACK FOOTER //
// ./src/modules/Forms/Normalize/min.js